<template>
  <div class="assets-item" :class="{ 'active': isActive }">
    <el-skeleton :loading="imgLoading" animated class="w-full h-full">
      <template slot="template">
        <el-skeleton-item variant="image" style="width: 60px; height: 60px;" />
      </template>
      <template>
        <img class="assets-item__pic object-contain" :src="url" alt="pic" @error="onerror(url)" @click.stop="handleSelect">
      </template>
    </el-skeleton>
    <div v-if="isActive" class="assets-item__check">
      <i class="el-icon-check" />
    </div>
    <popover v-model="popoverVisible" popper-class="assets-item__popper" :visible-arrow="false" placement="bottom-end">
      <div>
        <div class="popover-content flex items-center">
          <i class="el-icon-warning text-danger text-18" />
          <span class="text-white ml-1">确定删除图片吗？</span>
        </div>
        <div class="flex items-center mt-4 w-full justify-end">
          <span class="text-textColor-3 hover:text-white cursor-pointer" @click="handleCancel">取消</span>
          <div
            class="submit-btn w-[50px] h-[24px] flex items-center text-white justify-center bg-primary cursor-pointer rounded-sm ml-4"
            @click="handleSubmit">确定</div>
        </div>
      </div>
      <div slot="reference" class="assets-item__delete">
        <icon-delete class="text-white" />
      </div>
    </popover>
  </div>
</template>

<script>
import { Popover, Skeleton, SkeletonItem } from 'element-ui'
import iconDelete from '@/assets/svg/icon/iconDelete.svg'
export default {
  name: 'AssetsItem',
  components: {
    iconDelete,
    Popover,
    [Skeleton.name]: Skeleton,
    [SkeletonItem.name]: SkeletonItem
  },
  props: {
    url: {
      type: String,
      default: ''
    },
    isActive: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      popoverVisible: false,
      imgLoading: true
    }
  },
  watch: {
    url: {
      handler(val) {
        if (val) {
          this.loadImage()
        }
      },
      immediate: true
    }
  },
  methods: {
    loadImage() {
      this.imgLoading = true
      const img = new Image()
      img.src = this.url
      img.onload = () => {
        this.imgLoading = false
      }
      img.onerror = () => {
        this.onerror()
        this.imgLoading = false
      }
    },
    handleCancel() {
      this.popoverVisible = false
    },
    onerror() {
      this.$emit('remove')
      this.handleCancel()
    },
    handleSelect() {
      this.$emit('select', this.url)
      this.handleCancel()
    },
    handleSubmit() {
      this.$emit('remove')
      this.handleCancel()
    }
  }
}
</script>

<style lang="less">
.assets-item__popper {
  background-color: #303030;
  border: 1px solid #303030;
}

.assets-item {
  flex-shrink: 0;
  width: 60px;
  height: 60px;
  cursor: pointer;
  border-radius: @border-radius-base;
  border: 2px solid transparent;
  overflow: hidden;
  position: relative;
  transition: border-color 0.2s, box-shadow 0.2s;

  &.active {
    border-color: @primary-1;
    box-shadow: 0 0 0 3px rgba(63, 84, 242, 0.25);

    .assets-item__pic {
      opacity: 0.85;
    }
  }

  &__pic {
    width: 100%;
    height: 100%;
    position: relative;
    transition: opacity 0.2s;
  }

  &__check {
    position: absolute;
    left: 2px;
    top: 2px;
    width: 18px;
    height: 18px;
    background-color: @primary-1;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 12px;
    z-index: 2;
  }

  &__delete {
    position: absolute;
    right: 2px;
    top: 2px;
    width: 18px;
    height: 18px;
    background-color: rgba(24, 23, 28, 0.36);
    border-radius: @border-radius-base;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;

    &:hover {
      color: white;
      background-color: @danger-color;
    }
  }
}
</style>
